import {takeLatest} from 'redux-saga/effects';
import * as constants from './constants';
import * as saga from './saga';

export default function*() {
    yield takeLatest(constants.POST_LOG_ITEM.REQUEST, saga.postItemLog);
}